import { useContext } from 'react';

import { SessionContext } from '@/contexts/Session/SessionContext';

export default function useSession() {
  const context = useContext(SessionContext);

  if (!context) {
    throw new Error('useSession must be used within SessionContext');
  }

  return context;
}
